export const createTourIdSelector = (id: string) => `[data-tourid="${id}"]`;

export const createTestIdSelector = (id: string) => `[data-testid="${id}"]`;
